import React, { useMemo } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { CompanyDocumentQueryData } from '@area-restrita/api-client/model/companyDocumentQueryData';
import { getGetDocumentsQueryOptions } from '@area-restrita/api-client/endpoints/company-document/company-document.gen';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { useQueryTable } from '@/hooks/useQueryTable';
import DataGrid from '@/components/DataGrid';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';
import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';
import PageContainer from '@/components/layout/PageContainer';
import CompanyQueryFilter from '@/components/QueryFilters/CompanyFilter';
import DocumentCategoryFilter from '@/components/QueryFilters/DocumentCategoryFilter';

import CreateCompanyDocument from '../../components/create-company-document';
import { columns, companyColumns } from './columns';

const CompanyDocuments: React.FC = () => {
  const navigate = useNavigate();
  const { checkAuthorization, getUserType } = useAuthSessionStore();
  const userType = getUserType();

  const canListCompanies = checkAuthorization(({ can }) =>
    can('list', 'companies'),
  );

  const canCreate = checkAuthorization(({ can }) => can('create', 'documents'));
  const canViewDetails = checkAuthorization(({ can }) =>
    can('viewDetails', 'documents'),
  );

  const columnsVisibles = useMemo(() => {
    if (userType === 'tenant') return columns;
    return companyColumns;
  }, [userType]);

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns: columnsVisibles,
    getQueryOptions: getGetDocumentsQueryOptions,
  });

  return (
    <PageContainer title="Documentos">
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        toolbar={
          <div className="flex items-center space-x-2">
            <DataTableToolbar
              table={table}
              searchPlaceholder="Buscar documento..."
              searchColumnId="search"
            />
            <DocumentCategoryFilter
              title="Categoria"
              column={table.getColumn('categoryIds')}
            />
            {userType === 'tenant' && canListCompanies && (
              <CompanyQueryFilter
                title="Empresa"
                column={table.getColumn('companyIds')}
              />
            )}
          </div>
        }
        actions={
          userType === 'tenant' &&
          canCreate && (
            <Dialog
              title="Novo Documento"
              trigger={<Button size="sm">Adicionar Documento</Button>}
            >
              <CreateCompanyDocument />
            </Dialog>
          )
        }
        onRowClick={
          canViewDetails
            ? (row: CompanyDocumentQueryData) => {
                navigate({
                  to: '/documents/$companyDocumentPublicId',
                  params: { companyDocumentPublicId: row.publicId },
                });
              }
            : undefined
        }
        // emptyState={{
        //   title: 'Nenhum documento encontrado',
        //   actionDescription: 'Adicione um novo documento',
        // }}
      />

      {/* <PageDataTable
        columns={columns}
        getQueryOptions={getGetDocumentsQueryOptions}
        actions={
          canCreate && (
            <Dialog
              title="Novo Documento"
              trigger={<Button size="sm">Adicionar Documento</Button>}
            >
              <CreateCompanyDocument />
            </Dialog>
          )
        }
        emptyState={{
          title: 'Nenhum documento encontrado',
          actionDescription: 'Adicione um novo documento',
        }}
        toolbar={
          <div className="flex items-center space-x-2">
            <DataTableFacetedFilter
              title="Empresa"
              options={companies}
              column={null}
            />
          </div>
        }
        filters={[
          { columnId: 'prefix', title: 'Prefix', options: [] },
          { columnId: 'company', title: 'Empresa', options: companies },
        ]}
        onRowClick={
          canViewDetails
            ? (row: CompanyDocumentQueryData) => {
                navigate({
                  to: '/documents/$companyDocumentPublicId',
                  params: { companyDocumentPublicId: row.publicId },
                });
              }
            : undefined
        }
        seachColumnId="name"
        searchPlaceholder="Encontre um documento"
      /> */}
    </PageContainer>
  );
};

export default CompanyDocuments;
